import axiosInstance from 'api/axiosInstance';

const getDocumentURI = async (filePath: string): Promise<{ url: string }> => {
  const getDocumentUrl = `/v2/users/file-url?filePath=${filePath}`;
  return axiosInstance.get(getDocumentUrl);
};

export default getDocumentURI;
